import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Btn } from 'src/app/core/interfaces';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.less'],
})
export class ButtonComponent implements OnInit {
  @Input() button: Btn;
  @Input() disabled: boolean = false;
  @Output() btnEvent: EventEmitter<string> = new EventEmitter();

  constructor() {
    if (!this.button) {
      this.button = {
        type: 'primary',
      };
    }
  }

  ngOnInit(): void {}

  btnClick(e: Event, value: string) {
    e.preventDefault();

    this.btnEvent.emit(value);
  }
}
